<script setup lang="ts">
import { ServiceFormats, type IService } from '@types';
import type { Hierarchy } from '@ui/styles';
import { getMinPriceByService } from '@sub/utils/CuePriceLib2/ServicePriceLib';
import { usePriceFormatter } from '@sub/utils/prices';

withDefaults(defineProps<{
  hierarchy?: Hierarchy,
  service?: IService,
  showServicePrice?: boolean,
}>(), {
  service: () => ({} as IService),
  showServicePrice: true,
});

const { formatPrice } = usePriceFormatter();
</script>

<template lang="pug">
UiButton.white-space-nowrap(
  size="small"
  :to="`/booking/${service.id}`"
  :hierarchy="hierarchy"
)
  template(v-if="service.format === ServiceFormats.without || !showServicePrice")
    | {{ $t('block.service.info.page.button.booking.text.base') }}
  template(v-else)
    | {{ $t('block.service.info.page.button.booking.text.from') }}
    | {{ formatPrice(getMinPriceByService(service)) }}
</template>
